import { all, call, put, takeLatest } from '@redux-saga/core/effects';
import axios from 'axios';

import { requestCreateTeam, requestViewTeam, requestUpdateTeam, requestDeleteTeam } from './team.actions';
import { getCreateTeamRequest, getViewTeamRequest, getUpdateTeamRequest, getDeleteTeamRequest } from './team.endpoints';
import { CREATING_TEAM, RETRIEVING_TEAM, UPDATING_TEAM, DELETING_TEAM } from './team.constants';

import { addSystemNotice, addSpinner, removeSpinner } from '../../slices/system/system.slice';
import { addTeam, changeTeamName, setTeam, removeTeam } from '../../slices/programme/team/team.slice';

import { SUCCESS, ERROR } from '../../utils/constants';
import { getErrorMessage } from '../../utils/api-util';

export function* performCreateTeamRequest({ payload }) {
  const { team, onSuccess } = payload;

  try {
    yield put(addSpinner(CREATING_TEAM));

    const request = getCreateTeamRequest(team);

    const { data } = yield call(axios, ...request);

    yield put(addTeam(data.team));

    if (onSuccess) {
      yield call(onSuccess);
    }

    yield put(addSystemNotice({ type: SUCCESS, message: data.message }));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner(CREATING_TEAM));
  }
}

export function* watchForCreateTeamRequest() {
  yield takeLatest(requestCreateTeam.type, performCreateTeamRequest);
}

export function* performViewTeamRequest({ payload }) {
  const { externalReference } = payload;

  try {
    yield put(addSpinner(RETRIEVING_TEAM));

    const request = getViewTeamRequest(externalReference);

    const { data } = yield call(axios, ...request);

    yield put(setTeam(data.team));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner(RETRIEVING_TEAM));
  }
}

export function* watchForViewTeamRequest() {
  yield takeLatest(requestViewTeam.type, performViewTeamRequest);
}

export function* performUpdateTeamRequest({ payload }) {
  const { team, onSuccess } = payload;

  try {
    yield put(addSpinner(UPDATING_TEAM));

    const request = getUpdateTeamRequest(team);

    const { data } = yield call(axios, ...request);

    yield put(changeTeamName(data.team));

    if (onSuccess) {
      yield call(onSuccess);
    }

    yield put(addSystemNotice({ type: SUCCESS, message: data.message }));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner(UPDATING_TEAM));
  }
}

export function* watchForUpdateTeamRequest() {
  yield takeLatest(requestUpdateTeam.type, performUpdateTeamRequest);
}

export function* performDeleteTeamRequest({ payload }) {
  const { externalReference, onSuccess } = payload;

  try {
    yield put(addSpinner(DELETING_TEAM));

    const request = getDeleteTeamRequest(externalReference);

    const { data } = yield call(axios, ...request);

    yield put(removeTeam(externalReference));

    if (onSuccess) {
      yield call(onSuccess);
    }

    yield put(addSystemNotice({ type: SUCCESS, message: data.message }));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner(DELETING_TEAM));
  }
}

export function* watchForDeleteTeamRequest() {
  yield takeLatest(requestDeleteTeam.type, performDeleteTeamRequest);
}

export default function* teamSaga() {
  yield all([
    watchForCreateTeamRequest(),
    watchForViewTeamRequest(),
    watchForUpdateTeamRequest(),
    watchForDeleteTeamRequest()
  ]);
}
